import React from "react";
import { Target, Eye } from "lucide-react";

const VisionMission = () => {
  return (
    <section id="vision" className="vision-mission">
      <div className="section-container">
        <div className="section-header">
          <h2 className="section-title">Vision & Mission</h2>
        </div>
        
        <div className="vision-mission-content">
          <div className="vision-card">
            <div className="card-icon">
              <Eye />
            </div>
            <h3 className="card-title">Vision</h3>
            <p className="card-description">
              To become a global leader in innovative technologies that empower and inspire.
            </p>
          </div>

          <div className="mission-card">
            <div className="card-icon">
              <Target />
            </div>
            <h3 className="card-title">Mission</h3>
            <p className="card-description">
              To design and deliver technology solutions that simplify complexities, drive growth, 
              and open new possibilities for our clients.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VisionMission;